import { MARQUEE_ITEMS } from "../data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE_ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-serif-display italic text-2xl sm:text-3xl lg:text-4xl text-[#F4F1EE]/90 px-6 whitespace-nowrap">
          {item}
        </span>
        <svg width="16" height="16" viewBox="0 0 16 16" className="shrink-0">
          <path
            d="M8 0 L9.5 6.5 L16 8 L9.5 9.5 L8 16 L6.5 9.5 L0 8 L6.5 6.5 Z"
            fill="#E6C594"
          />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative py-8 border-y border-[#282338] bg-[#0c0a11] overflow-hidden"
  >
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);
